
import { Component, Vue, } from 'vue-property-decorator';
import { isBadRequestResult, } from '~/api/error-helpers';
import { Store, } from '~/apps/account/store';
import FeedbackBox from '~/components/feedback-box/feedback-box.vue';
import HeaderText from '~/components/header-text/header-text.vue';

@Component({
	components: {
		HeaderText,
		FeedbackBox,
	},
	metaInfo: {
		title: 'Register - Link expired - Southern Water',
	},
})
export default class RegisterLinkExpired extends Vue {

	apiError: string | null = null;
	token = '';
	mailTriggered = false;

	mounted() {
		Store.commit.register.setStep(4);
		const getTokenFromSession = sessionStorage.getItem('registerEmailToken');
		if (getTokenFromSession) {
			this.token = getTokenFromSession;
		} else {
			this.apiError = this.invalidTokenMessage();
		}
	}

	invalidTokenMessage() {
		return 'Sorry, this link has now expired. You’ll need to complete a new registration.';
	}

	handleClick() {
		Store.commit.showSpinner();
		this.$selfServeApi.registerAccountResendRegistrationLinkCreate({
			activationCode: this.token,
			isDigitalBillingPromo: false,
		})
			.then(() => {
				this.mailTriggered = true;
			})
			.catch((error) => {
				let apiError = `Please wait a few minutes and try again. If the problem persists, please <a target="_blank" href=${this.contactUsLocation}>contact us</a>.`;
				if (isBadRequestResult(error) && Array.isArray(error.errors)) {
					apiError = error.errors[0].message;
				}
				this.apiError = apiError;
			})
			.finally(() => {
				Store.commit.hideSpinner();
			});
	}

	contactUsLocation = Store.getters.getGlobalConfigValue('ContactUsLocation');
}
